






































































































import { Component, Inject, Vue } from "vue-property-decorator";
import { IDelegatesMethods, IDelegatesProvider } from "./delegatesProvider.vue";

@Component
export default class DelegatesTable extends Vue {
  // Inject
  @Inject({ from: "delegatesProvider" })
  public readonly $delegatesProvider!: () => IDelegatesProvider;

  @Inject({ from: "delegatesMethods" })
  public readonly $delegatesMethods!: IDelegatesMethods;

  // Computed

  public get delegatesData() {
    return this.$delegatesProvider();
  }

  public get delegates() {
    return this.delegatesData.mappedDelegates;
  }

  public async revokeAccess(id, email) {
    await this.$delegatesMethods.revokeAccess(id, email);
    this.$emit("updated");
  }
}
